import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customs-tarif-lang',
  templateUrl: './customs-tarif-lang.component.html',
  styleUrls: ['./customs-tarif-lang.component.css']
})
export class CustomsTarifLangComponent implements OnInit {
    customsTarifId;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.customsTarifId = this.stateService.getStateParams()['customstarif_id'];
    }

    private async loadLanguages() {
        if (!!this.customsTarifId) {
            this.inputListLanguages = await this.datatask.Post(1730, { customstarif_id: this.customsTarifId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1731, { records: this.inputListLanguages }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    customstarif_id: number;
    customstarif_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customsTarifLang', {
//        templateUrl: 'views/components/views/customsTarifLang/customsTarifLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'customsTarifLangService', function ($stateParams, stateService, modalService, translateService, customsTarifLangService) {
//            const vm = this;
//            let customsTarifId = $stateParams.customstarif_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListTarifs: [],
//                lockedSave: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadLanguages() {
//                vm.model.inputListTarifs = await customsTarifLangService.listCustomsTarifLanguages({ customstarif_id: customsTarifId });
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                customsTarifLangService.saveObj({ records: vm.model.inputListTarifs }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            }
//        }]
//    });
//})();
